"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.common = void 0;
const TableLexer = __importStar(require("../table-lexer"));
// NOTE Remind that all regular exps use `^` which means beginning.
const table_lexer = TableLexer.build([
    ["identifier", "^\\s*([_\\p{Letter}][_\\p{Letter}0-9]*)\\s*", "u"],
    ["string", '^\\s*("(\\\\.|[^"])*")\\s*'],
    ["number", "^\\s*(\\d+\\.\\d+|\\d+|-\\d+\\.\\d+|-\\d+)\\s*"],
    ["symbol", "^\\s*([^_\\p{Letter}0-9\\s])\\s*", "u"],
]);
function lex(text) {
    return text.trim().length === 0 ? [] : table_lexer.lex(text);
}
function match_parentheses(left, right) {
    return ((left === "(" && right === ")") ||
        (left === "[" && right === "]") ||
        (left === "{" && right === "}"));
}
function parens_check(text) {
    const tokens = lex(text);
    const stack = [];
    for (const token of tokens) {
        if (token.label === "symbol" &&
            ["(", ")", "[", "]", "{", "}"].includes(token.value)) {
            if (["(", "[", "{"].includes(token.value)) {
                stack.push(token);
            }
            else {
                const top = stack.pop();
                if (top === undefined) {
                    return { kind: "excess", token };
                }
                else if (!match_parentheses(top.value, token.value)) {
                    return { kind: "mismatch", token };
                }
            }
        }
    }
    const top = stack.pop();
    if (top === undefined) {
        return { kind: "balance" };
    }
    else {
        return { kind: "lack", token: top };
    }
}
function parens_depth(text) {
    let depth = 0;
    const tokens = lex(text);
    const stack = [];
    for (const token of tokens) {
        if (token.label === "symbol" &&
            ["(", ")", "[", "]", "{", "}"].includes(token.value)) {
            if (["(", "[", "{"].includes(token.value)) {
                stack.push(token);
            }
            else {
                const top = stack.pop();
                if (top === undefined) {
                    throw new Error("parentheses excess");
                }
                else if (!match_parentheses(top.value, token.value)) {
                    throw new Error("parentheses mismatch");
                }
            }
        }
    }
    return stack.length;
}
exports.common = {
    lex,
    parens_check,
    parens_depth,
};
//# sourceMappingURL=common.js.map